import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class UserConsentRestServices {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);
	
	getGeneralConsents(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/consent/general', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getBookingConsents(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/consent/booking', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	updateGeneralConsents(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/user/consent/general/update', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	updateXRoadConsents(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/user/consent/general/update/xroad', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	updateBookingConsents(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/user/consent/booking/update', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
}